/***
 * Returns a read-only version of `stream`
 */
export const toReadable = (stream) => ({
    on: stream.on,
    dispose: stream.dispose,
    isDisposed: stream.isDisposed,
    onValue: stream.onValue
});
